import { CardCvcElement, CardExpiryElement, CardNumberElement } from '@stripe/react-stripe-js';
import { styled } from 'styled-components';

import { ReactComponent as Close } from '../../assets/icons/closeModal.svg';
export const XIcon = styled(Close)`
  cursor: pointer;
  &:hover {
    path {
      stroke: #be6a59;
    }
  }
`;
export const ModalButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  @media (max-width: 600px) {
    flex-direction: column;
    justify-content: center;
    gap: 15px;
  }
`;

export const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 24px;
`;

export const ButtonModalSubscribe = styled.button`
  border-radius: 16px;
  border: 1px solid #262626;
  display: flex;
  width: 100%;
  height: 54px;
  padding: 16px 4px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  background: #262626;
  cursor: pointer;
  color: #fffdfc;
  text-align: justify;

  font-size: 16px;
  font-style: normal;
  font-family: 'Poppins-Medium';

  line-height: 22px; /* 137.5% */
  letter-spacing: -0.408px;

  &:active {
    transition: all 0.2s ease-in-out;
    scale: 0.95;
  }
`;

export const ModalTitle = styled.span`
  color: #000;
  text-align: justify;
  font-family: 'Playfair Display';
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 39px; /* 162.5% */
`;

export const ButtonModal = styled(ButtonModalSubscribe)`
  background: '#000';
  border: none;
`;

export const InputRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: 2px;
  align-items: center;
  padding-top: 24px;
  padding-bottom: 24px;
`;

export const ButtonModalCancel = styled.button`
  border-radius: 16px;
  border: 1px solid #be6a59;
  display: flex;
  width: 160px;
  padding: 16px 4px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  background: white;
  cursor: pointer;

  color: #1e1e1e;
  text-align: justify;

  font-size: 16px;
  font-style: normal;
  font-family: 'Poppins-Medium';

  line-height: 22px; /* 137.5% */
  letter-spacing: -0.408px;

  &:active {
    transition: all 0.2s ease-in-out;
    scale: 0.95;
  }
`;

export const InputCardNumberElement = styled(CardNumberElement)`
  width: 100%;
  align-items: center;
  gap: 10px;
  padding: ${props => (props.$icon ? '12px 12px 12px 48px' : '12px 12px 12px 12px')};
  border-top: none;
  border-left: none;
  border-right: none;
  border-bottom: none;
  border-bottom: 1px solid #e2dddb;
  &:focus {
    outline: none;
    border-bottom: 1px solid #000;
  }

  color: #000;
  text-align: justify;

  font-size: 18px;
  font-style: normal;
  font-family: 'Poppins-Medium';

  letter-spacing: -0.2px;
`;

export const InputCardExpiryElement = styled(CardExpiryElement)`
  width: 100%;
  align-items: center;
  gap: 10px;
  padding: ${props => (props.$icon ? '12px 12px 12px 48px' : '12px 12px 12px 12px')};
  border-top: none;
  border-left: none;
  border-right: none;
  border-bottom: none;
  border-bottom: 1px solid #e2dddb;
  &:focus {
    outline: none;
    border-bottom: 1px solid #000;
  }

  font-size: 18px;
  font-family: 'Poppins-Medium';

  letter-spacing: -0.2px;
  background-color: transparent;
`;

export const InputCardCvcElement = styled(CardCvcElement)`
  width: 100%;
  align-items: center;
  gap: 10px;
  padding: ${props => (props.$icon ? '12px 12px 12px 48px' : '12px 12px 12px 12px')};
  border-top: none;
  border-left: none;
  border-right: none;
  border-bottom: none;
  border-bottom: 1px solid #e2dddb;
  &:focus {
    outline: none;
    border-bottom: 1px solid #000;
  }
  &::placeholder {
    //opacity: 0.5;
  }
  color: #000;
  font-family: 'Poppins-Medium';

  font-size: 16px;
  letter-spacing: -0.2px;
  background-color: transparent;
`;

export const TotalContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: flex-end;
  padding-top: 24px;
  padding-bottom: 24px;
`;

export const Total = styled.span`
  font-size: 18px;

  font-family: 'Poppins-Medium';

  letter-spacing: -0.2px;
  opacity: 0.5;
`;

export const TotalNumber = styled.span`
  font-family: 'Poppins-SemiBold';

  font-size: 20px;

  letter-spacing: -0.2px;
`;

export const TotalRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;
`;
